import { IEmployeeSalaryScalesOverviewRow, EmployeesService } from "../../../services/index";

class SalaryscalesOverviewController implements ng.IComponentController {
    private rows: IEmployeeSalaryScalesOverviewRow[] = [];
    private loading: boolean = true;

    constructor(private EmployeesService: EmployeesService) {
        'ngInject';
    }

    $onInit() {
        this.load();
    }

    load() {
        this.loading = true;
        this.EmployeesService.getSalaryScalesOverview().then((result: IEmployeeSalaryScalesOverviewRow[]) => {
            this.rows = result || [];
            this.loading = false;
        }).catch(() => {
            this.loading = false;
        });
    }
}

export const salaryscalesOverviewComponent: ng.IComponentOptions = {
    controller: SalaryscalesOverviewController,
    template: require('./salaryscales.overview.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/salaryscales-overview/salaryscales.overview.component.ts